import { useMemo } from "react";
import type { DriverOption } from "components/CardDriverArea/coverageAreaDrivers";
import type { SlotRow } from "../CardDriverAreaMap/useMapAreaDriverSelection";

interface UseMapDriversInlineFormParams {
  slotRows: SlotRow[];
  options: DriverOption[];
}

export function useMapDriversInlineForm({
  slotRows,
  options,
}: UseMapDriversInlineFormParams) {
  const optionsForSlot = useMemo(() => {
    return slotRows.map((row) => {
      const takenIds = new Set(
        slotRows
          .filter((other) => other.key !== row.key && other.value?.id)
          .map((other) => other.value!.id),
      );
      return options.filter((option) => !takenIds.has(option.id));
    });
  }, [slotRows, options]);

  return { optionsForSlot };
}
